import JSPDF from 'jspdf';

export const generatePDF = (paymentDetails: any) => {
    // Create a new jsPDF instance
    const pdf = new JSPDF();

    const logoImg = './0a6e5c81-7861-485a-9546-c00537c6ae9a.jpeg';
    pdf.addImage(logoImg, 'JPEG', 15, 10, 30, 10);

    // Set font
    pdf.setFont('Helvetica', 'normal');

    // Add double-line border around the entire page
    pdf.setLineWidth(2);
    pdf.rect(5, 5, 200, 287);

    // Add background color to the title
    pdf.setFillColor(3, 120, 151);
    pdf.rect(7, 7, 196, 20, 'F');

    // Set title text color
    pdf.setTextColor(255, 255, 255);
    pdf.setFontSize(24);
    pdf.text('SEVA Invoice', 105, 20, { align: 'center' });

    

    // Set text color back to black
    pdf.setTextColor(0, 0, 0);

    // Add horizontal line
    pdf.setLineWidth(0.5);

    // Add payment details with improved styling
    pdf.setFontSize(14);
    pdf.text(`Program Name: ${paymentDetails.programName}`, 20, 50); // Move "Program Name" up
    pdf.text(`Date: ${paymentDetails.date}`, 20, 60);
    pdf.text(`Amount: $${paymentDetails.amount.toFixed(2)}`, 20, 70);
    pdf.text(`Payment Reference Id: ${paymentDetails.paymentReferenceId}`, 20, 80);

    // Add a decorative line
    pdf.setLineWidth(0.3);
    // pdf.line(20, 77, 185, 77); // Move the line down

   // Add a thank you message
    pdf.setFontSize(18);
    pdf.text('Thank you for your payment!', 105, 260, { align: 'center' });

    // Add the health-related line
    pdf.setFontSize(14);
    pdf.text("Empower your life with our health programs – because a healthy you is a wealthy you.", 105, 285, { align: 'center' });

    // Save the PDF
    const filePath = 'payment_receipt.pdf';
    pdf.save(filePath);

    console.log(`Attractive payment receipt saved to ${filePath}`);

};